// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d9749a7d","581":"b6075595"}[chunkId] + ".chunk.js";
};